// The contact page renders entirely from code: ContactUsPage.js builds its content
// from defaultPageData (the Formspree contact form), so there is no hosted "Pages"
// asset to fetch. We intentionally do NOT request content/pages/contact_us_page.json
// from the Asset Delivery API — that asset was never created in Sharetribe Console,
// so fetching it 404'd on every SSR hit and logged a `page-asset-fetch-failed` error
// to Sentry. Returning a resolved promise keeps the loadData contract intact.
export const loadData = () => () => Promise.resolve();
